import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import CommercialLayout from "../../components/layouts/CommercialLayout";
import api from "../../services/api";

const typeConfig = {
  "Creation credit":          { bg: "#E6F1FB", text: "#185FA5",  icon: "💳", label: "Crédit créé" },
  "Remboursement a temps":    { bg: "#f0fdf4", text: "#16a34a",  icon: "✓",  label: "Remboursé à temps" },
  "Remboursement retard <24h":{ bg: "#fefce8", text: "#ca8a04",  icon: "⏱", label: "Retard < 24h" },
  "Remboursement retard >24h":{ bg: "#fff7ed", text: "#ea580c",  icon: "⚠", label: "Retard > 24h" },
  "Retard >24h":              { bg: "#fff7ed", text: "#ea580c",  icon: "⚠", label: "Retard > 24h" },
  "Remboursement tres tardif":{ bg: "#fef2f2", text: "#dc2626",  icon: "⚠", label: "Très tardif" },
  "Remboursement tardif":     { bg: "#fef2f2", text: "#dc2626",  icon: "⚠", label: "Tardif" },
  "NonRembourse":             { bg: "#fef2f2", text: "#dc2626",  icon: "✕",  label: "Non remboursé" },
  "Echeance proche":          { bg: "#fff7ed", text: "#ea580c",  icon: "🔔", label: "Échéance proche" },
  "Client a risque":          { bg: "#fff7ed", text: "#ea580c",  icon: "⚠", label: "Client à risque" },
  "Client bloque":            { bg: "#fef2f2", text: "#dc2626",  icon: "🔒", label: "Client bloqué" },
};

const getConfig = (type) => typeConfig[type] || { bg: "#f3f4f6", text: "#6b7280", icon: "ℹ", label: type };

const Alertes = () => {
  const { utilisateur } = useAuth();
  const [alertes, setAlertes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtre, setFiltre] = useState("tous");

  useEffect(() => {
    const fetchAlertes = async () => {
      try {
        const res = await api.get(`/alertes/commercial/${utilisateur.commercialId}`);
        setAlertes(res.data);
        // Marquer toutes comme lues automatiquement
        await api.put(`/alertes/commercial/${utilisateur.commercialId}/tout-lire`);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    if (utilisateur?.commercialId) fetchAlertes();
  }, [utilisateur]);

  const types = ["tous", ...new Set(alertes.map(a => a.type))];

  const alertesFiltrees = alertes.filter(a =>
    filtre === "tous" || a.type === filtre
  );

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleString("fr-FR", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit"
    });
  };

  return (
    <CommercialLayout>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Alertes</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>
            {alertes.length} alerte(s) au total
          </p>
        </div>
      </div>

      {/* Filtres par type */}
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "1.25rem" }}>
        {types.map((type) => {
          const active = filtre === type;
          return (
            <button
              key={type}
              onClick={() => setFiltre(type)}
              style={{
                padding: "0.4rem 0.9rem", borderRadius: "9999px", fontSize: "12px",
                border: active ? "none" : "1px solid #e5e7eb",
                backgroundColor: active ? "#185FA5" : "white",
                color: active ? "white" : "#6b7280",
                cursor: "pointer", fontWeight: active ? "500" : "400"
              }}
            >
              {type === "tous" ? "Toutes" : getConfig(type).label}
              {type !== "tous" && (
                <span style={{ marginLeft: "4px", fontSize: "11px" }}>
                  ({alertes.filter(a => a.type === type).length})
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Liste alertes */}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {loading ? (
          <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280", fontSize: "14px" }}>Chargement...</div>
        ) : alertesFiltrees.length === 0 ? (
          <div style={{ padding: "3rem", textAlign: "center" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>🔔</div>
            <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucune alerte</p>
          </div>
        ) : (
          alertesFiltrees.map((alerte) => {
            const cfg = getConfig(alerte.type);
            return (
              <div
                key={alerte.id}
                style={{
                  backgroundColor: "white",
                  border: `0.5px solid ${alerte.lu ? "#e5e7eb" : "#185FA5"}`,
                  borderRadius: "12px", padding: "1rem",
                  display: "flex", gap: "12px", alignItems: "flex-start",
                  opacity: alerte.lu ? 0.85 : 1
                }}
              >
                {/* Icône type */}
                <div style={{
                  width: "36px", height: "36px", borderRadius: "10px",
                  backgroundColor: cfg.bg, display: "flex", alignItems: "center",
                  justifyContent: "center", fontSize: "14px", flexShrink: 0
                }}>
                  {cfg.icon}
                </div>

                {/* Contenu */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px", flexWrap: "wrap" }}>
                    <span style={{
                      fontSize: "11px", padding: "2px 8px", borderRadius: "6px",
                      backgroundColor: cfg.bg, color: cfg.text, fontWeight: "500"
                    }}>
                      {cfg.label}
                    </span>
                    {!alerte.lu && (
                      <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#185FA5", display: "inline-block" }} />
                    )}
                  </div>
                  <p style={{ fontSize: "13px", color: "#374151", margin: "0 0 4px", lineHeight: 1.5 }}>
                    {alerte.message}
                  </p>
                  <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                    {formatDate(alerte.date)}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </CommercialLayout>
  );
};

export default Alertes;